/* Cotton Creatives Creative Vault shared interactions */
(function(){
  function initCreativeVaults(root){
    const scope = root || document;

    scope.querySelectorAll('.cc-vault').forEach(function(vault){
      if(vault.dataset.ccVaultInitialized === 'true') return;
      vault.dataset.ccVaultInitialized = 'true';

      const navButtons = Array.from(vault.querySelectorAll('.cc-vault-nav-button[data-vault-target]'));
      const panels = Array.from(vault.querySelectorAll('[data-vault-panel]'));
      const mobileMenu = vault.querySelector('.cc-vault-mobile-menu');
      const mobileToggle = vault.querySelector('.cc-vault-mobile-toggle');
      const mobileCurrent = vault.querySelector('[data-mobile-current]');
      const mobileIcon = vault.querySelector('[data-mobile-icon]');
      const recentKey = 'ccCreatorVaultRecentV1';

      const routeAliases = {
        'digital-products': 'products'
      };

      const panelLabels = {
        home: 'Vault Home',
        'my-businesses': 'My Businesses',
        'business-matcher': 'Business Matcher',
        'product-ideas': 'Product Idea Generator',
        'start-business': 'Start a Business',
        'business-workspace': 'Business Workspace',
        'business-builder': 'Business Builder',
        blueprints: 'Business Blueprints',
        'funnel-builder': 'Funnel + Automation',
        'launch-center': 'Finished Business',
        'marketing-system': 'Marketing System',
        ai: 'AI Vault',
        prompts: 'Prompt Vault',
        images: 'Image Vault',
        products: 'Digital Product Vault',
        coloring: 'Coloring Book Vault',
        ugc: 'UGC Vault',
        faceless: 'Faceless Vault',
        briefcase: 'Creator Briefcase'
      };

      function normalizeTarget(target){
        return routeAliases[target] || target;
      }

      function readJson(key, fallback){
        try{
          return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
        }catch(error){
          return fallback;
        }
      }

      function writeJson(key, value){
        try{
          localStorage.setItem(key, JSON.stringify(value));
        }catch(error){}
      }

      function rememberRecent(target){
        const normalized = normalizeTarget(target);
        if(!normalized) return;

        let recent = readJson(recentKey, []);
        if(!Array.isArray(recent)) recent = [];

        recent = recent
          .map(normalizeTarget)
          .filter(Boolean)
          .filter(function(item, index, array){
            return array.indexOf(item) === index;
          });

        recent = [normalized]
          .concat(recent.filter(function(item){ return item !== normalized; }))
          .slice(0, 6);

        writeJson(recentKey, recent);
      }

      function getMatchingNav(target){
        const normalized = normalizeTarget(target);
        return navButtons.find(function(button){
          return button.getAttribute('data-vault-target') === normalized;
        }) || null;
      }

      function openPanel(target, selectedButton){
        const normalized = normalizeTarget(target);
        if(!normalized) return;

        const matchingPanel = panels.find(function(panel){
          return panel.getAttribute('data-vault-panel') === normalized;
        });

        if(!matchingPanel) return;

        navButtons.forEach(function(button){
          button.classList.toggle(
            'is-active',
            button.getAttribute('data-vault-target') === normalized
          );
        });

        panels.forEach(function(panel){
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-vault-panel') === normalized
          );
        });

        const activeButton = selectedButton || getMatchingNav(normalized);

        if(mobileCurrent){
          const label =
            activeButton?.getAttribute('data-mobile-label') ||
            activeButton?.querySelector('.cc-vault-nav-label')?.textContent ||
            panelLabels[normalized] ||
            'Creative Vault';

          mobileCurrent.textContent = label.trim();
        }

        if(mobileMenu) mobileMenu.classList.remove('is-open');
        if(mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
        if(mobileIcon) mobileIcon.textContent = '+';

        rememberRecent(normalized);
        updateBriefcase();

        const top = vault.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      navButtons.forEach(function(button){
        button.addEventListener('click', function(){
          openPanel(button.getAttribute('data-vault-target'), button);
        });
      });

      vault.addEventListener('click', function(event){
        const trigger = event.target.closest('[data-open-vault]');
        if(!trigger || !vault.contains(trigger)) return;

        const target = normalizeTarget(trigger.getAttribute('data-open-vault'));
        const matching = getMatchingNav(target);
        openPanel(target, matching);
      });

      if(mobileToggle && mobileMenu){
        mobileToggle.addEventListener('click', function(){
          const open = !mobileMenu.classList.contains('is-open');
          mobileMenu.classList.toggle('is-open', open);
          mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if(mobileIcon) mobileIcon.textContent = open ? '−' : '+';
        });
      }

      /* AI Vault shared accordion behavior */
      vault.querySelectorAll('.cc-ai-module-head').forEach(function(head){
        head.addEventListener('click', function(){
          const module = head.closest('.cc-ai-module');
          if(!module) return;

          const isOpen = module.classList.toggle('is-open');
          head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

          const icon = head.querySelector('.cc-ai-module-icon');
          if(icon) icon.textContent = isOpen ? '−' : '+';
        });
      });

      const aiSearch = vault.querySelector('[data-ai-search]');
      if(aiSearch){
        aiSearch.addEventListener('input', function(){
          const query = aiSearch.value.trim().toLowerCase();

          vault.querySelectorAll('[data-ai-module]').forEach(function(module){
            const searchable =
              (module.getAttribute('data-search-text') || '') +
              ' ' +
              module.textContent;

            module.hidden = !!query && !searchable.toLowerCase().includes(query);
          });
        });
      }

      /* Image Vault builder only.
         Search, filters, favorites and card-copy behavior belong to the Image Vault snippet. */
      const ivFields = Array.from(vault.querySelectorAll('[data-iv-builder]'));
      const ivOutput = vault.querySelector('[data-iv-output]');
      const ivBuilderCopy = vault.querySelector('[data-iv-builder-copy]');
      const ivBuilderClear = vault.querySelector('[data-iv-builder-clear]');

      function buildImagePrompt(){
        if(!ivOutput || !ivFields.length) return;

        const values = {};
        ivFields.forEach(function(field){
          values[field.getAttribute('data-iv-builder')] = field.value.trim();
        });

        const purpose = values.purpose || '[choose the image purpose]';
        const subject = values.subject || '[describe the exact subject or product]';
        const style = values.style || '[choose a visual style]';
        const setting = values.setting || '[describe the setting]';
        const details = values.details || '[add the visual details that must be accurate]';
        const lighting = values.lighting || '[choose the lighting]';
        const composition = values.composition || '[choose the composition]';
        const ratio = values.ratio || '[choose the final format]';
        const avoid = values.avoid || 'warped text, extra objects, distorted anatomy or altered branding';

        ivOutput.textContent =
          'IMAGE BRIEF\n\n' +
          'PURPOSE:\n' + purpose + '\n\n' +
          'SUBJECT:\n' + subject + '\n\n' +
          'STYLE:\n' + style + '\n\n' +
          'SCENE:\nPlace the subject in ' + setting + '. Include ' + details + '.\n\n' +
          'LIGHTING AND COMPOSITION:\nUse ' + lighting + ' with ' + composition + '. Format the image for ' + ratio + '.\n\n' +
          'ACCURACY:\nKeep important product, person, text and brand details visually accurate. Avoid ' + avoid + '.';
      }

      ivFields.forEach(function(field){
        field.addEventListener('input', buildImagePrompt);
        field.addEventListener('change', buildImagePrompt);
      });

      if(ivBuilderCopy){
        ivBuilderCopy.addEventListener('click', async function(){
          const prompt = ivOutput?.textContent?.trim() || '';
          if(!prompt) return;

          try{
            await navigator.clipboard.writeText(prompt);
          }catch(error){
            const area = document.createElement('textarea');
            area.value = prompt;
            document.body.appendChild(area);
            area.select();
            document.execCommand('copy');
            area.remove();
          }

          const oldText = ivBuilderCopy.textContent;
          ivBuilderCopy.textContent = 'Copied';
          setTimeout(function(){
            ivBuilderCopy.textContent = oldText || 'Copy My Image Brief';
          }, 1400);
        });
      }

      if(ivBuilderClear){
        ivBuilderClear.addEventListener('click', function(){
          ivFields.forEach(function(field){
            if(field.tagName === 'SELECT') field.selectedIndex = 0;
            else field.value = '';
          });
          buildImagePrompt();
        });
      }

      buildImagePrompt();

      /* Digital Product Vault builder only.
         Search, filters, favorites and card-copy behavior belong to the Digital Product Vault snippet. */
      const dpFields = Array.from(vault.querySelectorAll('[data-dp-builder]'));
      const dpOutput = vault.querySelector('[data-dp-output]');
      const dpBuilderCopy = vault.querySelector('[data-dp-builder-copy]');
      const dpBuilderClear = vault.querySelector('[data-dp-builder-clear]');

      function buildDigitalProductBrief(){
        if(!dpOutput || !dpFields.length) return;

        const values = {};
        dpFields.forEach(function(field){
          values[field.getAttribute('data-dp-builder')] = field.value.trim();
        });

        const audience = values.audience || '[name the buyer]';
        const stage = values.stage || '[describe where the buyer is now]';
        const problem = values.problem || '[state the specific problem]';
        const outcome = values.outcome || '[state the customer result]';
        const format = values.format || '[choose a product format]';
        const includes = values.includes || '[list the essential files, pages, lessons or templates]';
        const price = values.price || '[choose a starting price range]';
        const time = values.time || '[choose a realistic creation timeline]';
        const channel = values.channel || '[choose where you may sell it]';
        const angle = values.angle || '[explain why this product would be useful]';

        dpOutput.textContent =
          'DIGITAL PRODUCT BRIEF\n\n' +
          'BUYER:\n' + audience + '\n\n' +
          'BUYER STAGE:\n' + stage + '\n\n' +
          'PROBLEM:\n' + problem + '\n\n' +
          'CUSTOMER RESULT:\n' + outcome + '\n\n' +
          'PRODUCT FORMAT:\n' + format + '\n\n' +
          'WHAT IT INCLUDES:\n' + includes + '\n\n' +
          'SUGGESTED STARTING PRICE:\n' + price + '\n\n' +
          'CREATION PLAN:\nBuild a useful version within ' + time + '.\n\n' +
          'WHERE YOU MAY SELL IT:\n' + channel + '\n\n' +
          'WHY THIS PRODUCT WOULD BE USEFUL:\n' + angle + '\n\n' +
          'NEXT STEP:\nUse this brief as your creation plan, then build the product one section or asset at a time.';
      }

      dpFields.forEach(function(field){
        field.addEventListener('input', buildDigitalProductBrief);
        field.addEventListener('change', buildDigitalProductBrief);
      });

      if(dpBuilderCopy){
        dpBuilderCopy.addEventListener('click', async function(){
          const brief = dpOutput?.textContent?.trim() || '';
          if(!brief) return;

          try{
            await navigator.clipboard.writeText(brief);
          }catch(error){
            const area = document.createElement('textarea');
            area.value = brief;
            document.body.appendChild(area);
            area.select();
            document.execCommand('copy');
            area.remove();
          }

          const oldText = dpBuilderCopy.textContent;
          dpBuilderCopy.textContent = 'Copied';
          setTimeout(function(){
            dpBuilderCopy.textContent = oldText || 'Copy My Product Brief';
          }, 1400);
        });
      }

      if(dpBuilderClear){
        dpBuilderClear.addEventListener('click', function(){
          dpFields.forEach(function(field){
            if(field.tagName === 'SELECT') field.selectedIndex = 0;
            else field.value = '';
          });
          buildDigitalProductBrief();
        });
      }

      buildDigitalProductBrief();

      /* Briefcase data bridge.
         The Briefcase snippet owns its folders, downloads and checklist.
         Shared JS only keeps saved counts and recent Vaults aligned with production storage keys. */
      function readSavedUnion(keys){
        const items = [];

        keys.forEach(function(key){
          const stored = readJson(key, []);
          if(!Array.isArray(stored)) return;

          stored.forEach(function(item){
            const value = typeof item === 'string' ? item : JSON.stringify(item);
            if(!items.includes(value)) items.push(value);
          });
        });

        return items;
      }

      function updateBriefcase(){
        const briefcasePanel = vault.querySelector('[data-vault-panel="briefcase"]');
        if(!briefcasePanel) return;

        const promptSaved = readSavedUnion([
          'ccCreatorVaultSavedPromptsV1',
          'creativeVaultSavedPrompts',
          'ccVaultSavedPrompts'
        ]);

        const imageSaved = readSavedUnion([
          'ccCreatorVaultSavedImagePromptsV1',
          'creativeVaultSavedImagePrompts',
          'ccVaultSavedImagePrompts'
        ]);

        const productSaved = readSavedUnion([
          'ccCreatorVaultSavedDigitalProductsV1',
          'creativeVaultSavedProductIdeas',
          'creativeVaultDigitalProductSaved',
          'ccVaultSavedProductIdeas'
        ]);

        const totalSaved = promptSaved.length + imageSaved.length + productSaved.length;

        const promptEl = briefcasePanel.querySelector('[data-bc-prompts]');
        const imageEl = briefcasePanel.querySelector('[data-bc-images]');
        const productEl = briefcasePanel.querySelector('[data-bc-products]');
        const savedEl = briefcasePanel.querySelector('[data-bc-saved]');

        if(promptEl) promptEl.textContent = promptSaved.length;
        if(imageEl) imageEl.textContent = imageSaved.length;
        if(productEl) productEl.textContent = productSaved.length;
        if(savedEl) savedEl.textContent = totalSaved;

        let recent = readJson(recentKey, []);
        if(!Array.isArray(recent)) recent = [];

        recent = recent
          .map(normalizeTarget)
          .filter(function(item){ return item && item !== 'briefcase'; })
          .filter(function(item, index, array){ return array.indexOf(item) === index; })
          .slice(0, 5);

        const recentCount = briefcasePanel.querySelector('[data-bc-recent-count]');
        if(recentCount) recentCount.textContent = recent.length;

        const recentList = briefcasePanel.querySelector('[data-bc-recent-list]');
        if(recentList){
          if(!recent.length){
            recentList.innerHTML = '<p>No recent Vaults yet.</p>';
          }else{
            recentList.innerHTML = recent.map(function(item){
              return '<button type="button" class="cc-bc-recent-link" data-open-vault="' + item + '">' +
                (panelLabels[item] || item) +
                '</button>';
            }).join('');
          }
        }
      }

      updateBriefcase();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      initCreativeVaults(document);
    });
  }else{
    initCreativeVaults(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initCreativeVaults(event.target || document);
  });
})();